//防止多次提交
console.log("ehehehe");
function setDisabled(obj) {
	obj.attr('disabled', 'disabled').addClass('disabled').html('正在提交......');
}
function removeDisabled(obj) {
	obj.removeAttr('disabled').removeClass('disabled').html('确认提交');
}

//设置时间格式
$('#datetimepicker').datepicker({
	format: 'yyyy-mm-dd',
	autoclose: true,
	language: 'zh-CN',
	todayHighlight:true,
	startDate:new Date(),
});

//表单验证
var valitor = $('#sheets').validate({
	errorClass : "validate-error",
	rules:{
		mobile:{
			required:true,
			mobilePhone: true
        },
		qq:{
			required:true,
			digits:true,
			minlength:5,
			maxlength:12,
		},
		email:{
    	required:true,
    	email:true,
    }
	},
});

$('.submit').on('click', function(event) {
		event.preventDefault();
		var that = $(this);
		setDisabled(that);
		if ($('#sheets').valid()) {
			$.ajax({
				// url:'/home/index/customize',
				type:'post',         
				dataType:'json',  
				data:$("#sheets").serialize(),
			})
			.done(function(data) {
				var data = JSON.parse(data);
				if (data.code=="200") {
					location.href = data.url;
				}else{
					removeDisabled(that);
					alert(data.msg);
				}
			})
			.fail(function() {
				removeDisabled(that);
				alert("提交失败,怀疑是网络不好，如你重新提交仍报错，请联络客服：400-096-0053");
			})
			.always(function() {
			});
		}else{
			var firserro = $('#sheets').find('.validate-error').first();
			$(window).scrollTop(firserro.offset().top-30);
			removeDisabled(that);
		}
	});
 



 




 


// WEBPACK FOOTER //
// ./src/pages/base/customize.js